<template>
    <div class="row mb-4 align-items-center">
        <div class="col-4">
            <span class="text-secondary">{{ label }}</span>
        </div>
        <div class="col-8">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DesignItem',
    props: {
        label: String,
    },
};
</script>
